import { ecorEnv } from '@/../environments/environment';
import { PortalUser } from '@/common/components/ecorr-store/portal-user/portal-user';
import { ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { Component, Inject, OnDestroy, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ExportSurveyDialogData } from '../../dialogs-data/export-survey-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-export-survey-dialog',
  templateUrl: './export-survey-dialog.component.html',
  styleUrls: ['./export-survey-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  providers: [
    ParadataEventService
  ]
})
export class ExportSurveyDialogComponent implements OnInit, OnDestroy {  
    private destroyRef = inject(DestroyRef);
    private paradataEventService = inject(ParadataEventService);
    private dialogRef = inject(MatDialogRef<ExportSurveyDialogComponent>);

    exportSurveyDialogData = inject(MAT_DIALOG_DATA) as ExportSurveyDialogData;

    // Signals for reactive state
    private isInitialized = signal<boolean>(false);
    private isVisible = signal<boolean>(true);

    // Computed properties
    isDialogInitialized = computed(() => this.isInitialized());
    isDialogVisible = computed(() => this.isVisible());

    constructor() { 
    }

    ngOnInit() {
        this.isInitialized.set(true);
    }

    cancel() {
        this.close('cancel');
    }

    close(value: any) {
        this.isVisible.set(false);
        this.dialogRef.close(value);
    }

    ngOnDestroy() {
        this.paradataEventService.flushParadataevents();
    }
}
